import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import Logo from './Logo';

const Header = ({ onToggleSidebar }) => {
  const { user, logout } = useUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="app-header d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        <button
          className="btn btn-link p-0 me-3"
          onClick={onToggleSidebar}
          style={{ textDecoration: 'none', color: '#6b7280' }}
        >
          <i className="bi bi-list" style={{ fontSize: '1.5rem' }}></i>
        </button>
        <div className="d-none d-md-block">
          <Logo color="#667eea" width="150px" />
        </div>
      </div>

      <div className="d-flex align-items-center gap-3">
        <div className="d-none d-md-flex align-items-center" style={{ color: '#4b5563' }}>
          <i className="bi bi-person-circle me-2" style={{ fontSize: '1.25rem' }}></i>
          <span style={{ fontSize: '0.875rem' }}>{user?.fullName || user?.email}</span>
        </div>
        <span className="badge d-none d-sm-inline" style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '0.35rem 0.65rem',
          fontSize: '0.75rem',
          fontWeight: '500'
        }}>
          {user?.role === 'super_admin' ? 'super_admin' : user?.role}
        </span>
        <button 
          className="btn btn-sm"
          onClick={handleLogout}
          style={{
            backgroundColor: 'transparent',
            color: '#6b7280',
            border: 'none',
            padding: '0.375rem 0.75rem',
            fontSize: '0.875rem'
          }}
        >
          <i className="bi bi-box-arrow-right me-1"></i>
          <span className="d-none d-sm-inline">Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
